import { mapState, mapActions } from 'vuex';
import i18n from '../../i18n/index';
import configRoutes from '../../utils/routerUtils';

const SESSION_MESSAGES = {
  inactive: 'Su sesión se cerró por inactividad.',
  replaced: 'Detectamos un inicio de sesión en otro dispositivo o ubicación. Por seguridad, cerramos esta sesión.',
  expired: 'Su sesión expiró, vuelva a ingresar su usuario y contraseña.'
};

export default {
  data() {
    return {
      valid: false,
      username: '',
      password: '',
      sessionExpirationMessage: null,
      rules: {
        required: value => !!value || i18n.t('field-required')
      },
      paths: []
    };
  },
  created() {
    const routeMessage = SESSION_MESSAGES[this.$route.query.reason];
    if (routeMessage) {
      this.sessionExpirationMessage = routeMessage;
      localStorage.setItem('session-expiration-message', routeMessage);
    }
  },
  computed: {
    ...mapState('auth', ['status'])
  },
  methods: {
    ...mapActions('auth', ['login']),
    clearSessionExpirationMessage() {
      localStorage.removeItem('session-expiration-message');
      this.sessionExpirationMessage = null;
      if (this.$route.query.reason) {
        this.$router.replace({ path: '/login' });
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        const { username, password } = this;
        this.login({ username, password })
          .then(user => {
            configRoutes(this.$router);
            this.$router.push('/');
          }).catch(error => {
            if (error && error.error === 'Invalid credentials') {
              this.$notify({
                group: "app",
                type: "error",
                text: i18n.t('login.invalid-credentials')
              });
              return;
            }

            this.$notify({
              group: "app",
              type: "error",
              text: i18n.t('login.error-occurred')
            });
          });
      }
    }
  }
};
